import { render, staticRenderFns } from "./Nonsupport.vue?vue&type=template&id=591c2e7a&scoped=true&"
import script from "./Nonsupport.vue?vue&type=script&lang=js&"
export * from "./Nonsupport.vue?vue&type=script&lang=js&"
import style0 from "./Nonsupport.vue?vue&type=style&index=0&id=591c2e7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591c2e7a",
  null
  
)

export default component.exports